export default __webpack_public_path__ + "static/media/6.ba7c92f3.jpg";